import type { TranslationLanguage } from '@gitbook/api-client';
import { createPalette, type PaletteDef } from '@gitbook/react-uikit';
import { Icon } from '@gitbook/spine-icons';

import { openAndDownloadCSVFile } from '../../../utils';
import type { GlossaryStateEntry } from './state';

/**
 * Create the palette for the more actions button in the glossary view.
 */
export function createGlossaryMorePalette({
    entries,
    displayedLanguages,
}: {
    entries: GlossaryStateEntry[];
    displayedLanguages: TranslationLanguage[];
}): PaletteDef {
    return createPalette({
        groups: [
            {
                key: 'actions',
                commands: [
                    {
                        key: 'download',
                        icon: Icon.Download,
                        title: 'Download glossary as CSV',
                        trigger: () => {
                            openAndDownloadCSVFile(
                                entries.map((entry) => {
                                    return entry.translations;
                                }),
                                displayedLanguages
                            );
                        },
                    },
                ],
            },
        ],
    });
}
